<template>
    <div class="settings-drawer" :class="{'drawer-opened': anyEditorOpened}" id="SETTINGS_EDITOR_DRAWER">
        <div class="editor-buttons">
            <button @click="closeAllEditors()" v-if="anyEditorOpened">
                <span class="e-icons e-close"></span>
            </button>
            <button v-for="component in openedEditors"
                :key="component.cId"
                v-on:click="selectActiveEditor(component.cId)"
                :class="{active: component.cId === visibleEditorId, loading: component.loading}"
                :title="component.cTitle"
            >
                <span class="active-indicator"></span>
                <span class="e-icons e-cog"></span>
            </button>
        </div>
        <ejs-sidebar id="component-settings-sidebar-menu" class="editor-sidebar-menu" type="Over" :width="settingsEditorWidth + 'px'" ref="sidebarInstance" :enable-gestures="false" zIndex="999999">
            <div v-for="component in loadedEditors" :key="component.cId">
                <settings-editor
                    v-show="visibleEditorId === component.cId"
                    :c-id="'settingsEditor__' + component.cId"
                    :prop-component-id="component.cId"
                    :editor-enabled="editorEnabled"
                    :prop-test-mode="testMode"
                    :prop-preset-view="component.presetView"
                    :prop-preview-id="component.previewId"
                    @update:column-count="setSidebarWidth($event)"
                ></settings-editor>
            </div>
        </ejs-sidebar>
    </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapMutations } from 'vuex';
import { library } from "@common/library/library";

const settingsDrawerComponent = {
    name: 'settingsDrawer',
    props: {},
    data() {
        return {
            editorEnabled: true,
            testMode: false,
            columnCount: 1
        };
    },
    computed: {
        settingsEditorWidth() {
            return this.columnCount * 560; // NOSONAR
        },
        openedEditors() {
            return this.$store.state.settingsEditorStore.openedEditors;
        },
        loadedEditors() {
            // There is a delay between an editor being opened (openedEditors)
            // and when the settings are loaded from the server
            // Only generate the settingsEditor component after the settings have loaded
            let output = {};
            let editorIds = Object.keys(this.openedEditors);
            editorIds.forEach((eId) => {
                let editor = this.openedEditors[eId];
                if (!editor.loading) output[eId] = editor;
            });
            return output;
        },
        anyEditorOpened() {
            return !library.objIsEmpty(this.openedEditors);
        },
        visibleEditorId() {
            return this.$store.state.settingsEditorStore.visibleEditorId;
        }
    },
    watch: {
        visibleEditorId(visibleEditorId) {
            if (visibleEditorId) this.$refs.sidebarInstance.show();
            else this.$refs.sidebarInstance.hide();
        }
    },
    methods: {
        ...mapMutations({
            setVisibleEditor: 'settingsEditorStore/setVisibleEditor',
            closeAllEditors: 'settingsEditorStore/closeAllEditors'
        }),
        selectActiveEditor(cId) {
            this.$refs.sidebarInstance.hide();
            setTimeout(() => {
                this.setVisibleEditor({ cId, toggle: true });
            }, 200);
        },
        setSidebarWidth(count) {
            this.columnCount = count;
        }
    },
    components: {
        "ejs-sidebar": defineAsyncComponent(() => import('@common/syncfusion/sidebar'))
    }
};

export default settingsDrawerComponent;
</script>

<style scoped lang="css">
.settings-drawer {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000000;
}
.editor-buttons {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000001;
    background: #ddd;
    border-right: 1px solid #ccc;
    height: 100%;
}
#component-settings-sidebar-menu {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    left: 41px !important;
    transition: width .3s ease-in;
    border-right: none !important;
}
.editor-buttons button {
    width: 40px;
    border: 0 none;
    background: none;
    height: 30px;
    border-bottom: 1px dotted #bbb;
    display: block;
    cursor: pointer;
}
.editor-buttons button .e-icons.e-cog {
    display: inline-block;
}
.active-indicator {
    display: none;
}
.editor-buttons button.active {
    background: #ffffff;
}
.editor-buttons button:hover {
    background: #eee;
}
.active .active-indicator {
    display: block;
    position: absolute;
    right: 4px;
    width: 5px;
    height: 5px;
    margin-top: -3px;
    border-radius: 3px;
    background: rgb(25, 118, 210);
}
.loading .e-icons.e-cog {
    animation: rotation 3s infinite ease;
}
@keyframes rotation {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
}
</style>

<style>
.settings-drawer.drawer-opened + * {
    padding-left: 40px;
}
</style>
